<div #videoContainer class="video-container">
    <!-- <iframe
      width="444"
      height="250"
      [src]="getSafeUrl(videoId)"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen>
    </iframe> -->
  </div>
